import { baseGlobals } from '@root/typescript/baseGlobals'

import DOM from '../DOM/DOM'

type TCallback<T extends Node> = (el: T) => void

/**
 * DOM-ból kikerülve meghívja a megadott callback-et.
 * @param el                     - Az elem, amit vizsgálunk.
 * @param onDisconnectedCallback - A callback, ami majd meghívódik.
 * @param willAutoDisconnect     - Automatikusan kikapcsolja az observert az első DOM attach után?
 */
export default function disconnectedCallback<T extends Node> (
  el: T,
  onDisconnectedCallback: TCallback<T>,
  willAutoDisconnect = true
): T {
  // eslint-disable-next-line no-restricted-globals
  const observer = new MutationObserver(() => {
    if (!DOM.isDetachedFromDOM(el)) {
      return
    }

    if (willAutoDisconnect) {
      observer.disconnect()
    }

    if (!baseGlobals.isTest) {
      onDisconnectedCallback(el)
    }
  })

  observer.observe(document, {
    childList: true,
    subtree: true
  })

  return el
}
